import R from 'ramda';
import inboxReducer, * as inboxReducerSelectors from './inboxReducer';
import { STATE_NAME } from '../constants';

export default inboxReducer;

const getInboxState = R.prop(STATE_NAME);

// inboxReducerSelectors
export const getBookings = R.pipe(
  getInboxState,
  inboxReducerSelectors.getBookings,
);

export const getInitial = R.pipe(
  getInboxState,
  inboxReducerSelectors.getInitial,
);
export const getBookingsKindData = R.pipe(
  getInboxState,
  inboxReducerSelectors.getBookingsKindData,
);
export const getCurrentKind = R.pipe(
  getInboxState,
  inboxReducerSelectors.getCurrentKind,
);
export const getCurrentListing = R.pipe(
  getInboxState,
  inboxReducerSelectors.getCurrentListing,
);
export const getCurrentQuery = R.pipe(
  getInboxState,
  inboxReducerSelectors.getCurrentQuery,
);
export const getDisplayParams = R.pipe(
  getInboxState,
  inboxReducerSelectors.getDisplayParams,
);
export const getExpandedListingsGroups = R.pipe(
  getInboxState,
  inboxReducerSelectors.getExpandedListingsGroups,
);
export const getListings = R.pipe(
  getInboxState,
  inboxReducerSelectors.getListings,
);
export const getCurrentListingObject = R.pipe(
  getInboxState,
  inboxReducerSelectors.getCurrentListingObject,
);
export const getPager = R.pipe(
  getInboxState,
  inboxReducerSelectors.getPager,
);
